import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { CommonConsult } from "../common-consult";

export const CustomerBanner = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="customer-banner">
        <div className="banner-content">
          {/* <div className="banner-image">
            <img
              src="//files.authing.co/authing-website/customer-banner-image.png"
              alt="authing"
            />
          </div> */}
          <div className="banner-title">
            <span className="banner-title-first">
              {t("customer.home.banner.title-first")}
            </span>
            <span className="banner-title-dot">，</span>
            <span>{t("customer.home.banner.title-second")}</span>
          </div>
          <div className="mobile-banner-consult">
            <CommonConsult
              aside={
                <div className="customer-button">
                  {t("common.button.consult")}
                </div>
              }
            />
          </div>
          <div className="banner-subtitle">
            {t("customer.home.banner.subtitle")}
          </div>
          <div className="banner-data-warp">
            <div className="data-item">
              <div className="item-label">
                {t("customer.home.banner.data-label-count")}
              </div>
              <div className="item-count">30000+</div>
            </div>
            <div className="data-item">
              <div className="item-label">
                {t("customer.home.banner.data-label-industry")}
              </div>
              <div className="item-count">20+</div>
            </div>
            <div className="data-item">
              <div className="item-label">
                {t("customer.home.banner.data-label-time")}
              </div>
              <div className="item-count">7/24</div>
            </div>
            <div className="data-item-consult">
              <CommonConsult
                aside={
                  <div className="customer-button">
                    {t("common.button.consult")}
                  </div>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
